module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/taola/font/notokr-light.woff2
// module id = 9YGl
// module chunks = 0